var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",[_c('h5',[_vm._v(_vm._s(_vm.timeLeft))])],{"time":_vm.timeLeftFormatted,"timeValue":_vm.timeLeft,"start":_vm.restartCountdown,"pause":_vm.stopCountdown,"proceed":_vm.startCountdown,"finished":_vm.timeLeft < 1})],2)}
var staticRenderFns = []

export { render, staticRenderFns }